export const padStart = (str: string, n: number, padChar = '0') =>
  (padChar.repeat(n) + str).slice(n * -1)
